import React, { useState, useEffect } from "react";

// components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Button,
    Spinner
} from "reactstrap";
import MaterialTable from 'material-table';
import Header from "../../../components/Headers/Header.jsx";

// style
import "../../../assets/css/loading.css";

// services
import { showMessage, showQuestion } from "../../../services/message.js";
import { api_DELETE, api_GET } from "../../../services/api_service.js";
import { getSessionCookie } from "../../../services/session.js";

//Constants
import { table_translate, table_style } from "../../../constants/MaterialTable.js";

export default function PontoColetaNaoExecucao({ history }) {

    const session = getSessionCookie()

    const [showLoading, setshowLoading] = useState(false);

    const [list_table, set_list_table] = useState([])
    const [list_loading, set_list_loading] = useState(false);

    const GetList = () => {
        set_list_loading(true);
        api_GET('pontocoleta/GetListNaoColetaLocal').then(result => {

            set_list_loading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
                return;
            }
            else {
                set_list_table(result.data);
            }
        });
    }

    const DeletaLocalNaoColeta = ({ pontoColetaId, endereco }) => {
        showQuestion("Deseja excluir o alerta?", endereco, "question", function (result) {
            if (result) {
                setshowLoading(true);
                api_DELETE(`pontocoleta/DeleteNaoColetaLocal/${pontoColetaId}/${session.usuarioId}`).then(result => {
                    setshowLoading(false);
                    if (result.status !== 204) {
                        showMessage("Aviso", result.message, 'error', null);
                        return;
                    }
                    else {
                        GetList();
                    }
                });
            }
        })
    }

    useEffect(() => {
        GetList();
    }, []);

    const columnsProp = [
        { title: 'Identificação', field: 'identificacao' },
        { title: 'Endereço', field: 'endereco' },
        { title: 'Modalidade de Serviço', field: 'modalidades' }
    ]

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <label style={{ marginRight: "20px" }}>Carregando...</label>
                        <Spinner size="sm" color="info" />
                    </div>
                </div>
            }
            <Header />
            <Container className="mt--9" fluid>
                <Row>
                    <Container className="mt-1" fluid>
                        <Card className="shadow">
                            <CardHeader className="border-0">
                                <Row>
                                    <Col md="6">
                                        <strong> Locais de Não Execução</strong>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col md="12">
                                        <MaterialTable
                                            title=""
                                            columns={columnsProp}
                                            data={list_table}
                                            isLoading={list_loading}
                                            options={{ ...table_style, pageSize: 20, pageSizeOptions: [20, 50, list_table.length] }}
                                            actions={[
                                                {
                                                    icon: 'delete',
                                                    tooltip: 'Deletar Registro',
                                                    onClick: (event, rowData) => DeletaLocalNaoColeta(rowData)
                                                }
                                            ]}
                                            localization={table_translate}
                                        />
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Container>
                </Row>
            </Container>

        </>
    );
}
